import { getRatingHintByInput } from './get-rating-hint-by-input';
import { removeRatingErrors } from './remove-rating-errors';
import { setRatingHint } from './set-rating-hint';

export type RatingChangeHandlerParams = {
    selectedInput: Pick<HTMLInputElement, 'id'>;
    rootElement: Pick<HTMLElement, 'querySelectorAll' | 'querySelector'>;
};
export const RatingChangeHandler =
    ({ selectedInput, rootElement }: RatingChangeHandlerParams) =>
    () => {
        const ratingHint = getRatingHintByInput({ input: selectedInput });
        setRatingHint({ ratingHint, rootElement });
        removeRatingErrors({ rootElement });
    };
